/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Group_Metadata_Remove_LabelInputs */



/**
* | output |
* | --- |
* | "Remove Metadata" |
*
* @param {Event_Group_Metadata_Remove_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_group_metadata_remove_label = /** @type {((inputs?: Event_Group_Metadata_Remove_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Group_Metadata_Remove_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Supprimer les métadonnées")
	if (locale === "de") return /** @type {LocalizedString} */ ("Metadaten entfernen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Rimuovi metadati")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Удалить метаданные")
	if (locale === "es") return /** @type {LocalizedString} */ ("Eliminar metadatos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("删除元数据")
	if (locale === "ja") return /** @type {LocalizedString} */ ("メタデータを削除する")
	if (locale === "hi") return /** @type {LocalizedString} */ ("मेटाडेटा हटाएँ")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Remover metadados")
	return /** @type {LocalizedString} */ ("Remove Metadata")
});